/* eslint-disable no-restricted-imports */
import { DateTime, Duration } from "luxon";
import { custom, type CustomIssue } from "valibot";

export * from "luxon";
export { DateTime } from "luxon";
export { DateZone } from "./DateZone";
export * from "./assertValidDateTime";
export * from "./addBusinessDays";

export function getAppTimeZone() {
    return "America/Toronto";
}

export const luxonDTValiType = (
    errorMessage?: string | ((input: CustomIssue) => string)
) => {
    const resp = custom<DateTime<true>>(
        (input) => DateTime.isDateTime(input) && input.isValid,
        (input) =>
            typeof errorMessage === "string"
                ? errorMessage
                : errorMessage?.(input) ?? `Invalid DateTime.`
    );

    Object.defineProperty(resp, "type", {
        value: "custom/luxonDateTime",
        writable: false,
    });
    return resp;
};

export const luxonDurationValiType = (
    errorMessage?: string | ((input: CustomIssue) => string)
) => {
    const resp = custom<Duration<true>>(
        (input) => Duration.isDuration(input) && input.isValid,
        (input) =>
            typeof errorMessage === "string"
                ? errorMessage
                : errorMessage?.(input) ?? `Invalid Duration.`
    );
    Object.defineProperty(resp, "type", {
        value: "custom/luxonDuration",
        writable: false,
    });
    return resp;
};
